import React, { createContext, useContext } from 'react';
import useWebHook from '../../hooks/Dashboard/useWeb';

export const WebContext = createContext();

export const WebProvider = ({ children }) => {
  const web = useWebHook(); // Import everything from the hook

  return (
    <WebContext.Provider value={web}>
      {children}
    </WebContext.Provider>
  );
};

export const useWeb = () => useContext(WebContext);